import { useEffect, useState } from "react";
import "../styles/inventory.css";
import { TextInput } from "../Components/TextInput";
import SideFormWrapper from "../Components/SideFormWrapper";
import axios from "axios";
export default function Inventory() {
  const [formState, setFormState] = useState(false);
  const [formData, setFormData] = useState(null);
  const [branchList, setBranchList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [inventory, setInventory] = useState([]);

  const toggleForm = (flag, edit = false, data = null) => {
    if (edit) {
      setFormData(data);
    }
    if (!flag) {
      setFormData(null);
    }
    setFormState(flag);
  };
  const ManageInventory = () => {
    return (
      <form
        method="POST"
        onClick={(e) => {
          e.stopPropagation();
        }}
        onSubmit={handleSubmit}
      >
        <select
          onChange={handleChange}
          name="branch"
          defaultValue={formData?.status || 0}
        >
          <option value={0}>Choose Branch</option>
          {branchList.map((e) => {
            return (
              <option value={e.id} key={e.id}>
                {e.location}
              </option>
            );
          })}
        </select>
        {productList.map((e) => {
          return (
            <TextInput
              name={e.id}
              label={e.name}
              data={formData?.quantity || 0}
              type={"special"}
              key={e.id}
            />
          );
        })}

        <section className="btns-section">
          <button>Confirm</button>
          <button
            id="cancel-btn"
            onClick={(e) => {
              toggleForm(false);
            }}
          >
            Cancel
          </button>
        </section>
      </form>
    );
  };
  function handleChange(e) {
    console.log(e.target.value);
  }
  function handleSubmit(e) {
    e.preventDefault();
    const submittedData = new FormData(e.target);
    const data = Object.fromEntries(submittedData.entries());

    axios
      .post(`${process.env.REACT_APP_LOCAL_API_URL}/admin/inventory`, {
        body: data,
      })
      .then((res) => {
        if (res.data.success) {
          toggleForm(false);
        } else {
          alert(res.data.error.message);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_LOCAL_API_URL}/admin/inventory`)
      .then((res) => {
        console.log(res.data);
        setInventory(res.data);
      });
    axios
      .get(`${process.env.REACT_APP_LOCAL_API_URL}/admin/branches`)
      .then((res) => {
        const list = res.data.map((e) => {
          return { id: e.id, location: e.location };
        });
        console.log(list);
        setBranchList(list);
      });
    axios
      .get(`${process.env.REACT_APP_LOCAL_API_URL}/admin/products`)
      .then((res) => {
        const list = res.data.data.map((e) => {
          return { id: e.id, name: e.product_name };
        });
        console.log(list);
        setProductList(list);
      });
  }, [formState]);
  return (
    <>
      {formState && (
        <SideFormWrapper
          children={<ManageInventory />}
          toggleForm={toggleForm}
        />
      )}
      <section className="page-title-section">
        <h1>Inventory</h1>
        <button
          className="btn"
          onClick={(e) => {
            toggleForm(true);
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-building-fill-add"
            viewBox="0 0 16 16"
          >
            <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.5-5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1a.5.5 0 0 1 1 0" />
            <path d="M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v7.256A4.5 4.5 0 0 0 12.5 8a4.5 4.5 0 0 0-3.59 1.787A.5.5 0 0 0 9 9.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .39-.187A4.5 4.5 0 0 0 8.027 12H6.5a.5.5 0 0 0-.5.5V16H3a1 1 0 0 1-1-1zm2 1.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5m3 0v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5m3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zM4 5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5M7.5 5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm2.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5M4.5 8a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z" />
          </svg>
          Manage Inventory
        </button>
      </section>
      <table className="inventory-table">
        <thead>
          <tr>
            <th>Branch</th>
            <th>Item</th>

            <th>Quantity</th>

            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {inventory &&
            inventory.map((item, idx) => (
              <tr key={idx}>
                <td>{item.branch}</td>
                <td>{item.name}</td>
                <td>{item.quantity}</td>

                <td>
                  <span
                    className={`status ${item.quantity < 10 ? "low" : "ok"}`}
                  >
                    {item.quantity < 10 ? "Low" : "OK"}
                  </span>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      {!inventory.length && (
        <p style={{ textAlign: "center" }}>No Inventory Registered</p>
      )}
    </>
  );
}
